import {useEffect, useMemo, useRef} from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import '@videojs/themes/dist/sea/index.css';
import {useDndAsset} from "domains/drag-and-drop";
import {useBreakpointValue} from "@chakra-ui/react";
import { v4 } from 'uuid';

type Props = {
    options: any;
    onReady?: Function;
}

export const VideoJS = ( props: Props ) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const { options, onReady } = props;
  const { isSelected } = useDndAsset();
  const isMobile = useBreakpointValue([true, true, false]);

  // videojs dispose will attempt to remove the node which causes all sorts of issues. This will destroy the node first then recreate it afterwards.
  const key = useMemo(() => v4(), [options]);

  useEffect(() => {
    //TODO: Determine if the video was playing and what position it was at and reset to the same position and start playing it again.
    const videoElement = videoRef.current;
    if (!videoElement) return;

    const player = playerRef.current = videojs(videoElement, options, () => {
      onReady && onReady(player);
    });

    return () => {
      player.dispose();
    }
  }, [onReady, options]);

  return (
    <div data-vjs-player key={key} style={{ pointerEvents: (isSelected || !isMobile) ? "initial" : "none" }}>
      <video ref={videoRef} className="video-js vjs-theme-sea" />
    </div>
  );
}

export default VideoJS;